import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LiveProvider, LiveEditor, LiveError, LivePreview } from 'react-live';
import theme from 'prism-react-renderer/themes/oceanicNext';
import { useMDXScope } from 'gatsby-plugin-mdx/context';
import styled from 'styled-components';
import { Box, Button, Icon } from '@houzz/ui';
import Code from '@houzz/icons/Code';

const StyledPreview = styled.section`
    padding: 40px;
`;

const StyledImport = styled.pre`
    font-size: 14px;
    padding: 10px 20px;
    background: #424242;
    margin: 0;
    color: #fff;
`;

const CodeSample = ({ children }) => {
    const { props } = children;
    const {
        importString,
        defaultOpen = false,
        transparentBg = false,
        showError = true,
        showPreview = true,
        noInline = false,
    } = props;
    const codeString = props.children.trim();
    const components = useMDXScope();
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const transparentBgProps = {
        backgroundImage:
            'linear-gradient(45deg, #F8F8F8 25%, transparent 25%), linear-gradient(-45deg, #F8F8F8 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #F8F8F8 75%), linear-gradient(-45deg, transparent 75%, #F8F8F8 75%)',
        backgroundSize: '20px 20px',
        backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
    };

    return (
        <Box
            as="section"
            bg="bg.primary"
            borderRadius="large"
            border="small"
            borderColor="border.primary"
            overflow="hidden"
            className="code-sample"
            {...(transparentBg ? transparentBgProps : {})}
        >
            <LiveProvider code={codeString} scope={components} theme={theme} noInline={noInline}>
                {showPreview && (
                    <>
                        <Button
                            icon={<Icon as={Code} />}
                            variant="link"
                            position="absolute"
                            onClick={() => setIsOpen((current) => !current)}
                            title={`${isOpen ? 'Hide source code' : 'Show source code'}`}
                        />
                        <LivePreview Component={StyledPreview} />
                    </>
                )}

                {isOpen && importString && (
                    <StyledImport>{`import { ${importString} } from '@houzz/ui';`}</StyledImport>
                )}
                {isOpen && <LiveEditor />}
                {showError && <LiveError />}
            </LiveProvider>
        </Box>
    );
};

CodeSample.propTypes = {
    children: PropTypes.node,
    defaultOpen: PropTypes.bool,
    importString: PropTypes.string,
    showError: PropTypes.bool,
    showPreview: PropTypes.bool,
    noInline: PropTypes.bool,
};

export default CodeSample;
